import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Env } from '../env';
import { Observable } from 'rxjs/Observable';
import { Param } from '../models/param';
import { ParamDto } from '../dto/param.dto';

@Injectable()
export class ParamService {

  constructor(private http: HttpClient, private global: Env) { }

  getDetail(): Observable<Param> {
    const url = this.global.param;
    console.log(url);
    return this.http.get(url).map((res: Param) => {
      console.log(res);
      return res;
    });
  }

  update(dto: ParamDto): Observable<Param> {
    const url = this.global.param;
    return this.http.post(url, JSON.stringify(dto)).map((res: Param) => {
      return res;
    });
  }
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/services/param.service.ts